import React, { useRef } from "react";
import { useState } from "react";
import { saveAs } from "file-saver";
import { Modal } from "react-bootstrap";
import userService from "../../../../services/user.service";
import { getFromLocalStorage } from "../../../../utils/webStorage";
import lodingProgressOrPleaseWait from "../../images/lodingProgressOrPleaseWait.gif";
import IconButton from "@mui/material/IconButton";
import MenuIcon from "@mui/icons-material/MoreVert";
import { Dialog, Popover } from "@material-ui/core";
import { FormGroup } from "@material-ui/core";
import { CircularProgress } from "@mui/material";
import SettingsPopup from "../../../../Common/SettingsPopup";
import {
  FaShare,
  FaDownload,
  FaTelegramPlane,
  FaEdit,
  FaTrash,
  FaTimes,
} from "react-icons/fa";
import {
  openConfirmationPopup,
  openFailDialog,
  openRenamePopup,
  openSuccessPopup,
} from "../../../../Redux/Actions/PopupActions";
import { useDispatch, useSelector } from "react-redux";
import CamelCaseString from "../../../../Common/CamelCaseString";
import { Form, Formik } from "formik";
import CustomDropDown from "../../../../Common/FormFields/CustomDropDown";
import validationSchema from "../../../../Validation/ValidationSchemas";
import FormikTextField from "../../../../Common/FormFields/FormikInputField";
import ActiveAthleteCoachesListPopup from "../../Popups/ActiveAthleteCoachesListPopup";
import { IsValueNull } from "../../../../Common/IsValueNull";
import ActiveGroupsList from "../../Popups/ActiveGroupsList";
import { convertM3u8ToMp4 } from "../../../../utils/m3u8ToMp4Url";

const ShareVideo = (props) => {
  const schoolId = getFromLocalStorage("schoolId");
  const userId = getFromLocalStorage("currentUserId");
  const dispatch = useDispatch();
  const [open, setOpen] = useState(false);
  const [athletes, setAthletes] = useState([]);
  const [coaches, setCoaches] = useState([]);
  const [teamAdmins, setTeamAdmins] = useState([]);
  const {
    item,
    eventId,
    eventMediaId,
    videoPath,
    videoName,
    videoData,
    seasonType,
    eventType,
    weekName,
    setVideoName,
    offSeasonEventName,
    practiceName,
    otherSeasonEventType,
    seasonName,
    isVideoFromHighlight,
    isVideoFromLibrary,
    selectedVideoPaths,
    setVideoPath,
    playlistId,
  } = props;
  const [pageLoader, setPageLoader] = useState(false);
  const [showAtheleteModal, setShowAtheleteModal] = useState(false);
  const [shareOption, setShareOption] = useState("");
  const [groupsPopup, setGroupsPopup] = useState(false);
  const [selectedGroups, setSelectedGroups] = useState([]);
  const [buttonLoading, setButtonLoading] = useState(false);
  const formRef = useRef();
  const logginUserId = useSelector(
    (state) => state?.loggedInUser?.userProfile?.email
  );
  const loginRole = getFromLocalStorage("loginRole");
  const [anchorE2, setAnchorE2] = React.useState(null);
  const open2 = Boolean(anchorE2);
  const handleClick = (event) => {
    event.stopPropagation();
    setAnchorE2(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorE2(null);
  };
  const callPostForFeed = async ({
    shareOption,
    videoTitle,
    videoDescription,
  }) => {
    const pageName = "CELL";
    const type = "VIDEO_SHARED";
    let selectedGroupNames = [];
    if (selectedGroups.length > 0) {
      selectedGroupNames = selectedGroups.map((item) => item.groupName);
    }
    try {
      setButtonLoading(true);
      await userService
        .postFeedMerge(
          videoData?.scheduleEvent
            ? videoData?.scheduleEvent?.id
            : videoData?.eventMedia?.scheduleEvent?.id,
          eventMediaId,
          shareOption,
          CamelCaseString(videoDescription),
          CamelCaseString(videoTitle),
          schoolId,
          athletes,
          coaches,
          teamAdmins
        )
        .then((res) => {
          const shareMediaId = res.data.data.id;
          //share option = 3 means share to group
          if (shareOption === 3) {
            userService.addActivityVideoShared(
              IsValueNull(videoData?.scheduleEvent?.schedule?.id),
              shareMediaId,
              schoolId,
              userId,
              pageName,
              type,
              selectedGroupNames
            );
          }
          setShareOption("");
          setCoaches([]);
          setAthletes([]);
          setTeamAdmins([]);
          setSelectedGroups([]);
          setButtonLoading(false);
          setOpen(false);
          openSuccessPopup(dispatch, {
            successPopUp: {
              message: "Video Shared Successfully.",
              open: true,
            },
          });
        });
    } catch (err) {
      setButtonLoading(false);
      openFailDialog(dispatch, {
        open: true,
        message: "Something Went Wrong",
      });
    }
  };

  const shareCoachAndAthletes = () => {
    setShowAtheleteModal(!showAtheleteModal);
  };

  const athleteForFeed = (id) => {
    let newArray = [...athletes, id];
    if (athletes.includes(id)) {
      newArray = newArray.filter((checkId) => checkId !== id);
    }
    setAthletes(newArray);
  };

  const coachesForFeed = (id) => {
    let newArray = [...coaches, id];
    if (coaches.includes(id)) {
      newArray = newArray.filter((checkId) => checkId !== id);
    }
    setCoaches(newArray);
  };

  const handleDownload = async () => {
    setPageLoader(true);
    let mp4Url = videoPath.endsWith(".m3u8")
      ? convertM3u8ToMp4(videoPath)
      : videoPath;
    fetch(mp4Url, { method: "GET" })
      .then((res) => {
        return res.blob();
      })
      .then((blob) => {
        saveAs(blob, videoName);
      })
      .catch((err) => {
        openFailDialog(dispatch, {
          open: true,
          message: "Failed to download the video.",
        });
      })
      .finally(() => {
        setPageLoader(false);
      });
  };

  const toggleAthleteCoachesDialog = (status) => {
    setShowAtheleteModal(status);
  };

  const shareOptionList = [
    {
      name: "Share On Feed",
      value: 1,
    },
    {
      name: "Share To Athletes / Coaches",
      value: 3,
    },
    {
      name: "Share To Groups",
      value: 3,
    },
  ];

  const handleDeleteVideo = () => {
    if (logginUserId === videoData?.createdBy || loginRole === "SCHOOL ADMIN") {
      openConfirmationPopup(dispatch, {
        confirmationPopup: {
          open: true,
          message: "Are You Sure You Want To Delete This Video?",
          btnColor: "red",
          btnText: "Delete",
          type: "Delete Video",
          eventMediaId: eventMediaId,
          seasonType: seasonType,
          eventType: eventType,
          weekName: weekName,
          offSeasonEventName: offSeasonEventName,
          practiceName: practiceName,
          otherSeasonEventType: otherSeasonEventType,
          videoId: videoData?.id,
          playlistId: playlistId,
          isVideoRenamed: false,
          seasonName: seasonName,
          isVideoFromHighlight: isVideoFromHighlight,
          selectedVideoPaths: selectedVideoPaths,
          setVideoPath: setVideoPath,
          isVideoFromLibrary: isVideoFromLibrary,
        },
      });
      handleClose();
    } else {
      openConfirmationPopup(dispatch, {
        confirmationPopup: {
          open: true,
          message: `You are not authorized user to delete this video, Please contact school admin or its owner : ${videoData?.createdBy} `,
          messageDialog: true,
        },
      });
    }
  };

  const handleRenameVideo = (e) => {
    openRenamePopup(dispatch, {
      renamePopup: {
        open: true,
        videoData: videoData,
        fieldToShow: "eventMediaCategory",
        seasonType: seasonType,
        eventType: eventType,
        weekName: weekName,
        offSeasonEventName: offSeasonEventName,
        practiceName: practiceName,
        otherSeasonEventType: otherSeasonEventType,
        videoId: videoData.id,
        playlistId: playlistId,
        isVideoRenamed: true,
        seasonName: seasonName,
        isVideoFromHighlight: isVideoFromHighlight,
        type: "rename-from-video-library",
        selectedVideoPaths: selectedVideoPaths,
        isVideoFromLibrary: isVideoFromLibrary,
      },
    });
    handleClose();
  };

  const handleVideoHighlightRequest = () => {
    openConfirmationPopup(dispatch, {
      confirmationPopup: {
        open: true,
        message:
          "Are You Sure You Want To Send This Video To Feature On ContendZone Highlights?",
        btnColor: "green",
        btnText: "Yes, Send",
        type: "Video Highlight",
        videoName: videoName,
        videoPath: convertM3u8ToMp4(videoPath),
        schoolId: schoolId,
        eventMediaId: eventMediaId,
        eventId: videoData?.scheduleEvent
          ? videoData?.scheduleEvent?.id
          : videoData?.eventMedia?.scheduleEvent?.id,
        //scheduleId: videoData.scheduleEvent.id,
        shareIdForHighlight: 4,
        videoDescription: "",
        videoTitle: "",
        schoolId,
        athletes,
        coaches,
      },
    });
    handleClose();
  };

  const toggleShareModal = (status) => {
    this.setState({ open: status });
  };

  const isChecked = (columnId, id) => {
    if (columnId === "1") {
      return coaches.includes(id);
    }
    return athletes.includes(id);
  };

  const handleListSubmit = () => {
    toggleAthleteCoachesDialog(false);
  };

  const toggleGroupListPopup = (status) => {
    setGroupsPopup(status);
  };

  const selectGroups = (group) => {
    let selectedGroupsCopy = [...selectedGroups];
    let groupAthelets = [];
    let groupCoaches = [];
    let groupTeamAdmins = [];
    const found = selectedGroupsCopy.some((item) => item.id === group.id);
    found
      ? (selectedGroupsCopy = selectedGroupsCopy.filter(
          (item) => item.id !== group.id
        ))
      : selectedGroupsCopy.push(group);
    selectedGroupsCopy?.map((item) => {
      item?.groupAthelets?.map((element) => groupAthelets?.push(element?.id));
      item?.groupCoaches?.map((element) => groupCoaches?.push(element?.id));
      item?.groupTeamAdmins?.map((element) =>
        groupTeamAdmins?.push(element?.id)
      );
    });
    setCoaches(groupCoaches);
    setAthletes(groupAthelets);
    setTeamAdmins(groupTeamAdmins);
    setSelectedGroups(selectedGroupsCopy);
  };

  const isGroupChecked = (group) => {
    const found = selectedGroups.some((item) => item.id === group.id);
    return found;
  };

  const isArrayEmpty = coaches.length > 0 || athletes.length > 0;
  const isGroupsArrayEmpty = selectedGroups.length > 0;

  const settingList = [
    {
      icon: <FaShare className="manage-section-iconss" />,
      name: "Share",
      handleSubmit: () => {
        setOpen(true);
        setAnchorE2(null);
      },
    },
    {
      icon: !pageLoader ? (
        <FaDownload className="manage-section-iconss" />
      ) : (
        <img src={lodingProgressOrPleaseWait} />
      ),
      name: !pageLoader && "Download",
      handleSubmit: handleDownload,
    },
    {
      icon: <FaTelegramPlane className="manage-section-iconss" />,
      name: "Send Highlight Request",
      handleSubmit: handleVideoHighlightRequest,
    },
    {
      icon: <FaEdit className="manage-section-iconss" />,
      name: "Rename",
      handleSubmit: handleRenameVideo,
    },
    {
      icon: <FaTrash className="manage-section-iconss delete-icon" />,
      name: "Delete",
      handleSubmit: handleDeleteVideo,
      isVideoFromHighlight,
    },
  ];

  const handleGroupListSubmit = () => {
    toggleGroupListPopup(false);
  };

  return (
    <>
      <div className={`menu-icon-button ${open2 && "hovered"}`}>
        <IconButton
          id="basic-button"
          aria-controls={open ? "basic-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={open ? "true" : undefined}
          onClick={handleClick}
          className="menu-icon-button videolibrary-checkbox-icon"
        >
          <MenuIcon className="fs-14" />
        </IconButton>
      </div>

      <Popover
        id="basic-menu"
        anchorEl={anchorE2}
        open={open2}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        disableScrollLock={true}
      >
        <div className="mg-top-10 action-menu-container mg-bottom-10">
          {
            <SettingsPopup
              settingList={settingList}
              isVideoFromLibrary={isVideoFromLibrary}
            />
          }
        </div>
      </Popover>

      {showAtheleteModal && (
        <ActiveAthleteCoachesListPopup
          open={showAtheleteModal}
          togglePopup={toggleAthleteCoachesDialog}
          isArrayEmpty={isArrayEmpty}
          setOption={setShareOption}
          coachesForFeed={coachesForFeed}
          athleteForFeed={athleteForFeed}
          isChecked={isChecked}
          ref={formRef}
          handleListSubmit={handleListSubmit}
        />
      )}

      {groupsPopup && (
        <ActiveGroupsList
          open={groupsPopup}
          togglePopup={toggleGroupListPopup}
          setOption={setShareOption}
          coachesForFeed={selectGroups}
          isArrayEmpty={isGroupsArrayEmpty}
          isChecked={isGroupChecked}
          ref={formRef}
          handleListSubmit={handleGroupListSubmit}
        />
      )}

      <Dialog
        id="dialogBoxRemove"
        className="dialog-stylee"
        open={open}
        onClose={() => toggleShareModal(false)}
        fullWidth
        maxWidth="md"
      >
        <div className="d-flex-space-between pd-10">
          <p className="fs-20 semi-bold">Share Video</p>
          <FaTimes
            onClick={() => {
              setShareOption("");
              setCoaches([]);
              setAthletes([]);
              setSelectedGroups([]);
              setOpen(false);
            }}
            className="crossview cp"
          />
        </div>
        <Modal.Body>
          <Formik
            initialValues={{
              shareOption: "",
              videoTitle: "",
              videoDescription: "",
            }}
            innerRef={formRef}
            validationSchema={validationSchema.shareVideoSchema}
            onSubmit={(values) => callPostForFeed(values)}
          >
            {(formik) => (
              <Form>
                <FormGroup>
                  <label className="fmlabel mt-6 semi-bold fs-18">
                    Share <span className="redstar">*</span>
                  </label>
                  <CustomDropDown
                    selected={shareOption}
                    setSelected={(value) => {
                      if (value === "Share To Athletes / Coaches") {
                        shareCoachAndAthletes();
                      } else if (value === "Share To Groups") {
                        setGroupsPopup(true);
                      }
                      setShareOption(value);
                    }}
                    formik={formik}
                    fieldName="shareOption"
                    defaultSelectOption="Select Share"
                    options={shareOptionList}
                    fieldToShow="name"
                    optionValue="value"
                  />
                </FormGroup>
                <div className="clear20"></div>
                <FormikTextField
                  label="Video Title"
                  formik={formik}
                  fieldName="videoTitle"
                  placeholder="Enter Video Title"
                  labelFontSize="fs-18"
                />
                <FormikTextField
                  label="Video Description"
                  formik={formik}
                  fieldName="videoDescription"
                  placeholder="Enter Video Description"
                  labelFontSize="fs-18"
                />
                <div className="d-flex-align-right">
                  <button
                    className={formik.isValid ? "saveBtn1" : "saveBtn1 activv"}
                    type="submit"
                    disabled={!formik.isValid}
                  >
                    {buttonLoading ? (
                      <CircularProgress size="1.5rem" className="white" />
                    ) : (
                      "Post"
                    )}
                  </button>
                </div>
              </Form>
            )}
          </Formik>
        </Modal.Body>
      </Dialog>
    </>
  );
};

export default ShareVideo;
